<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Castellanos">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Castellanos"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Ph. D. Edmundo Castellanos Pérez</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> ecastellmx@yahoo.com.mx
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> 1
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p></p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            INGENIERO (1985)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            ESCUELA SUPERIOR DE AGRICULTURA Y ZOOTECNIA
                            <br>
                            UNIVERSIDAD JUAREZ DEL ESTADO DE DURANGO, MEXICO.
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>(1988)</li>
                            <p>
                                UNIVERSIDAD AUTONOMA DE CHIHUAHUA.
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>(2000)</li>
                            <p>
                                NEW MEXICO STATE UNIVERSITY, USA.
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>FISIOLOGIA DE PASTIZALES</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/castellanos.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'Solarized manure and two irrigation methods on fruit yield of jalapeno chili (Capsicum annuum L. var. annuum). Maraña-Santacruz José Ángel, Edmundo Castellanos-Pérez, Cirilo Vázquez-Vázquez, Juan José Martínez-Ríos, Héctor Idilio Trejo-Escareño, Miguel Ángel Gallegos-Robles. Rev. FCA UNCUYO. 2018. 50(2): 105-117. ISSN impreso 0370-4661.',
                    publicacion: 2018,
                },
                {
                    numero: 2,
                    titulo: 'Rendimiento de chile jalapeño con lixiviado de lombriz con dos métodos de riego Maraña Santacruz José Ángel, Edmundo Castellanos Pérez, Cirilo Vázquez Vázquez, Juan José Martínez Ríos, Héctor Idilio Trejo Escareño, Miguel Ángel Gallegos Robles e Ignacio Orona Castillo. Terra Latinoamericana 36: 345-354. DOI: https://doi.org/10.28940/terra.v36i4.253',
                    publicacion: 2018,
                },
                {
                    numero: 3,
                    titulo: 'Satellite and field radiometry for the estimation of biomass production in a grassland site in state of Durango, Mexico. Gutiérrez-Guzmán Ulises Noel, Castellanos-Perez Edmundo, Serrato-Corona J. Santos, Martínez-Ríos Juan José, Chairez-Hernández Isaías. Range Management and Agroforestry 38 (2):158-164. Print ISSN : 0971-2070.',
                    publicacion: 2017,
                },
                {
                    numero: 4,
                    titulo: 'Growth models of peach fruit Prunus persica (L) in three handling systems. Díaz Martínez Joel, Chairez Hernández Isaias, Gurrola Reyes J. Natividad, Proal Nájera José Bernardo, González Güereca Martha Celina, Castellanos Pérez  Edmundo. Interciencia 42 (9): 597-602 ISSN: 0378-1844',
                    publicacion: 2017,
                },
                {
                    numero: 5,
                    titulo: 'Efecto de la fecha de siembra sobre el potencial forrajero de cultivares primaverales de canola en la Comarca Lagunera, México. Sánchez Martínez Humberto, David Guadalupe Reta Sánchez, J. Santos Serrato Corona, Uriel Figueroa Viramontes, José Antonio Cueto Wong, Edmundo Castellanos Pérez. ITEA 114(3): 223-242.   ISSN 1699-6887',
                    publicacion: 2018
                },
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'Producción de zacate navajita (Bouteloua gracilis) en un área sembrada en 2003 en Durango',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Efecto de la costra biológica en la infiltración de agua en dos sitios dominados por matorrales al noreste de Durango',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Control del gatuño (Mimosa biuncifera) al norte de Durango',
                    tipo: 'INTERNO'
                },
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
